import { useFormik } from 'formik';
import React, { useEffect, useState, useRef } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import { customStyles } from '../../../../HelperFunctions';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import axios from 'axios';
import { adminMainUrl } from '../../../../Config';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllApprovedCustomers,
  getCompanyBranch,
  getJobOrderEmployeeList,
  getUnusedQuotationByCompanyList,
  getUnusedQuotationByCustomerList,
  getJobOrderPortList,
} from '../../../../Redux/action/Joborder/JoborderAction';
import { getOrganisationAgentList } from '../../../../Redux/action/Organisation/OrganisationListAction';
import { getFFAirExpOrganisation } from '../../../../Redux/action/FreightForwarding/Console/FFAirExpAction';
import { getIncoterms } from '../../../../Redux/action/MasterAction';
import * as Yup from 'yup';

const AddJobOrderByQuotationOffcanvas2 = ({
  token,
  user_id,
  quotation_id,
  show,
  handleClose,
  companyName,
  handleChangeCompanyBranch,
  disableQuotationField,
  disableTransportMode,
  disableTransportType,
  loadingQuotation,
  trans_mode,
  trans_type,
  ChangeTransportMode,
  ChangeTransportType,
  company_id,
  disabledHasQuotation,
  resetCompanyName,
  set_Branch_company_id,
  branch_company_id,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [nextJobOrderNumber, setNextJobOrderNumber] = useState({ sequence: 1, year: '26' });
  const [loadingJobOrders, setLoadingJobOrders] = useState(false);
  const [jobOwnerName, setJobOwnerName] = useState('');

  // ---- State for Add Customer Modal ----
  const [showAddCustomerModal, setShowAddCustomerModal] = useState(false);
  const [customerForm, setCustomerForm] = useState({
    name: '',
    address: '',
    email: '',
    mobile: '',
    gst: '',
  });
  const [savingCustomer, setSavingCustomer] = useState(false);

  // ---- Ref to store newly created customer ID for auto-selection ----
  const pendingCustomerId = useRef(null);

  // ---- Fetch profile directly (bypass Redux) ----
  useEffect(() => {
    if (token && user_id) {
      const config = {
        headers: {
          'auth-token': token,
          'user_id': user_id,
          'Content-Type': 'application/json',
        },
      };
      axios
        .get(`${adminMainUrl}/api/get-profile-new`, config)
        .then((res) => {
          if (res.data.code === 200) {
            setJobOwnerName(res.data.data.name || '');
          } else {
            setJobOwnerName('');
          }
        })
        .catch((err) => {
          console.error('Profile fetch error:', err);
          setJobOwnerName('');
        });
    }
  }, [token, user_id]);

  // ---- Helper functions ----
  const getPrefix = (mode, type) => {
    if (mode === 'Air' && type === 'Export') return 'AE';
    if (mode === 'Air' && type === 'Import') return 'AI';
    if (mode === 'Sea' && type === 'Export') return 'SE';
    if (mode === 'Sea' && type === 'Import') return 'SI';
    return null;
  };

  const getFormattedJobNumber = (seq, year, mode, type) => {
    const prefix = getPrefix(mode, type);
    if (!prefix) return 'CDL/-----/-----/--';
    return `CDL/${prefix}/${seq.toString().padStart(5, '0')}/${year}`;
  };

  // ---- Static options ----
  const loadTypeOptions = [
    { value: 'FCL', label: 'FCL (Full Container Load)' },
    { value: 'LCL', label: 'LCL (Less than Container Load)' },
  ];

  const shipmentTypeOptions = [
    { value: '20DRY', label: "20' Dry Standard" },
    { value: '40DRY', label: "40' Dry Standard" },
    { value: '40DRYHC', label: "40' Dry High Cube" },
    { value: '45DRYHC', label: "45' Dry High Cube" },
    { value: '20TANK', label: "20' Tank" },
    { value: '40TANK', label: "40' Tank" },
    { value: '20REEF', label: "20' Reefer Standard" },
    { value: '40REEFHC', label: "40' Reefer High Cube" },
    { value: '40REEF', label: "40' Reefer Standard" },
    { value: '20OT', label: "20' Open Top" },
    { value: '40OT', label: "40' Open Top" },
    { value: '40OTHC', label: "40' Open Top High" },
    { value: '20FR', label: "20' Flat Rack" },
    { value: '40FR', label: "40' Flat Rack Standard" },
    { value: '40FRHC', label: "40' Flat Rack High" },
    { value: 'BULK', label: 'Bulk' },
    { value: 'BREAKBULK', label: 'Breakbulk' },
    { value: 'OTHER', label: 'Other' },
  ];

  // ---- Unit options ----
  const weightUnitOptions = [
    { value: 'Kg', label: 'Kg' },
    { value: 'Ton', label: 'Ton' },
  ];

  const dimensionUnitOptions = [
    { value: 'cm', label: 'cm' },
    { value: 'inches', label: 'inches' },
    { value: 'm', label: 'm' },
    { value: 'ft', label: 'ft' },
  ];

  // ---- Redux state for incoterms (using correct key: incotermsData) ----
  const { incotermsData, loadingIncoterms } = useSelector((state) => state?.MasterReducer || {});
  const [incotermOptions, setIncotermOptions] = useState([]);

  useEffect(() => {
    dispatch(getIncoterms());
  }, [dispatch]);

  useEffect(() => {
    if (incotermsData && Array.isArray(incotermsData)) {
      const arr = incotermsData.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setIncotermOptions(arr);
    } else {
      setIncotermOptions([]);
    }
  }, [incotermsData]);

  // ---- Validation Schema (consignee is now optional) ----
  const validationSchema = Yup.object().shape({
    is_direct_customer: Yup.boolean().nullable().required('Direct Customer selection is required'),
    trans_mode: Yup.string().required('Transport Mode is required'),
    trans_type: Yup.string().required('Transport Type is required'),
    job_owner_id: Yup.string().test({
      name: 'jobOwnerRequired',
      message: 'Job Owner is required',
      test: function (value) {
        const { trans_mode } = this.parent;
        if (trans_mode !== 'Sea') {
          return !!value;
        }
        return true;
      },
    }),
    customer_id: Yup.string().test({
      name: 'customerRequired',
      message: 'Customer is required',
      test: function (value) {
        const { is_direct_customer } = this.parent;
        if (is_direct_customer === true) {
          return !!value;
        }
        return true;
      },
    }),
    sub_agent_id: Yup.string().test({
      name: 'subAgentRequired',
      message: 'Sub Agent is required',
      test: function (value) {
        const { is_direct_customer } = this.parent;
        if (is_direct_customer === false) {
          return !!value;
        }
        return true;
      },
    }),
    other_customer_name: Yup.string().test({
      name: 'otherCustomerRequired',
      message: 'Please enter customer name',
      test: function (value) {
        const { is_direct_customer, customer_id } = this.parent;
        if (is_direct_customer === true && customer_id === 'other') {
          return !!value && value.trim().length > 0;
        }
        return true;
      },
    }),
    pol: Yup.string().test({
      name: 'polRequired',
      message: 'Port of Loading is required',
      test: function (value) {
        const { trans_mode } = this.parent;
        if (trans_mode === 'Sea') {
          return !!value;
        }
        return true;
      },
    }),
    pod: Yup.string().test({
      name: 'podRequired',
      message: 'Port of Discharge is required',
      test: function (value) {
        const { trans_mode } = this.parent;
        if (trans_mode === 'Sea') {
          return !!value;
        }
        return true;
      },
    }),
    load_type: Yup.string().test({
      name: 'loadTypeRequired',
      message: 'Load Type is required',
      test: function (value) {
        const { trans_mode } = this.parent;
        if (trans_mode === 'Sea') {
          return !!value;
        }
        return true;
      },
    }),
    shipment_type: Yup.string().test({
      name: 'shipmentTypeRequired',
      message: 'Shipment Type is required',
      test: function (value) {
        const { trans_mode } = this.parent;
        if (trans_mode === 'Sea') {
          return !!value;
        }
        return true;
      },
    }),
    // ❌ Removed consignee_id validation – it is now optional
    shipper: Yup.string().test({
      name: 'shipperRequired',
      message: 'Shipper is required for indirect Sea job',
      test: function (value) {
        const { trans_mode, is_direct_customer } = this.parent;
        if (trans_mode === 'Sea' && is_direct_customer === false) {
          return !!value && value.trim().length > 0;
        }
        return true;
      },
    }),
    total_weight: Yup.string().test({
      name: 'totalWeightRequired',
      message: 'Total Weight is required for FCL',
      test: function (value) {
        const { trans_mode, load_type } = this.parent;
        if (trans_mode === 'Sea' && load_type === 'FCL') {
          return !!value && value.trim().length > 0;
        }
        return true;
      },
    }),
  });

  // ---- Formik ----
  const formik = useFormik({
    initialValues: {
      is_direct_customer: null,
      trans_mode: '',
      trans_type: '',
      quotation_id: '',
      customer_id: '',
      customer_branch_id: '',
      job_owner_id: user_id ? String(user_id) : '',
      has_quotation: true,
      sub_agent_id: '',
      pol: '',
      pod: '',
      load_type: '',
      shipment_type: '',
      shipper: '',
      other_customer_name: '',
      consignee_id: '',
      total_weight: '',
      weight_unit: 'Kg',
      incoterm: '',
      dimension_length: '',
      dimension_width: '',
      dimension_height: '',
      dimension_unit: 'cm',
      lcl_weight: '',
      lcl_weight_unit: 'Kg',
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      // Prevent submission if "Other" customer is selected without creating a customer
      if (values.customer_id === 'other') {
        toast.error('Please create a customer first by clicking "Add New Customer".');
        return;
      }

      setDisableSubmit(true);
      const seq = nextJobOrderNumber.sequence || 1;
      const year = nextJobOrderNumber.year || new Date().getFullYear().toString().slice(-2);
      const jobOrderNo = getFormattedJobNumber(seq, year, values.trans_mode, values.trans_type);

      const payload = {
        job_order_no: jobOrderNo,
        trans_mode: values.trans_mode,
        trans_type: values.trans_type,
        job_owner_id: values.job_owner_id || null,
        has_quotation: values.has_quotation,
        is_direct_customer: values.is_direct_customer,
        customer_branch_id: values.customer_branch_id || null,
        pol: values.pol || null,
        pod: values.pod || null,
        load_type: values.load_type || null,
        shipment_type: values.shipment_type || null,
        shipper: values.shipper || null,
        other_customer_name: values.other_customer_name || null,
        consignee_id: values.consignee_id || null,
        total_weight: values.total_weight || null,
        weight_unit: values.weight_unit || null,
        incoterm: values.incoterm || null,
        dimension_length: values.dimension_length || null,
        dimension_width: values.dimension_width || null,
        dimension_height: values.dimension_height || null,
        dimension_unit: values.dimension_unit || null,
        lcl_weight: values.lcl_weight || null,
        lcl_weight_unit: values.lcl_weight_unit || null,
      };

      if (values.is_direct_customer === true) {
        if (values.customer_id === 'other') {
          payload.customer_id = null;
          payload.other_customer_name = values.other_customer_name;
        } else {
          payload.customer_id = values.customer_id;
        }
        payload.quotation_id = null;
      } else {
        payload.customer_id = values.sub_agent_id;
        payload.quotation_id = values.quotation_id ? values.quotation_id : null;
      }

      const config = {
        headers: {
          'auth-token': Cookies.get('token'),
          'user_id': Cookies.get('flexichain_user_id'),
        },
      };
      axios
        .post(`${adminMainUrl}/api/jobOrder/add`, payload, config)
        .then((response) => {
          if (response.status === 200) {
            toast.success(response?.data?.msg);
            setDisableSubmit(false);
            resetForm();
            navigate(`/flexichain/job-order/edit/${btoa(response.data.data.id)}`);
          } else {
            toast.error(response?.data?.msg);
            setDisableSubmit(false);
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(error.response?.data?.msg || error.message);
          setDisableSubmit(false);
        });
    },
  });

  // ---- Fetch latest job order number ----
  useEffect(() => {
    const fetchJobOrders = async () => {
      const mode = formik.values.trans_mode;
      const type = formik.values.trans_type;
      const prefix = getPrefix(mode, type);
      if (!show || !prefix) {
        const currentYear = new Date().getFullYear().toString().slice(-2);
        setNextJobOrderNumber({ sequence: 1, year: currentYear });
        return;
      }
      setLoadingJobOrders(true);
      try {
        const config = {
          headers: {
            'auth-token': Cookies.get('token'),
            'user_id': Cookies.get('flexichain_user_id'),
          },
        };
        const response = await axios.post(
          `${adminMainUrl}/api/jobOrder/latestJobOrderlist`,
          { prefix },
          config
        );
        const currentYear = new Date().getFullYear().toString().slice(-2);
        let maxSequence = 0;
        if (response.status === 200 && response.data?.data) {
          const latestJobNo = response.data.data.job_order_unique_no;
          if (latestJobNo) {
            const regex = new RegExp(`CDL/${prefix}/(\\d+)/\\d{2}`);
            const match = latestJobNo.match(regex);
            if (match) {
              const seq = parseInt(match[1], 10);
              if (!isNaN(seq)) maxSequence = seq;
            }
          }
        }
        const nextSequence = maxSequence + 1;
        setNextJobOrderNumber({ sequence: nextSequence, year: currentYear });
      } catch (error) {
        console.error(error);
        const currentYear = new Date().getFullYear().toString().slice(-2);
        setNextJobOrderNumber({ sequence: 1, year: currentYear });
      } finally {
        setLoadingJobOrders(false);
      }
    };
    fetchJobOrders();
  }, [show, formik.values.trans_mode, formik.values.trans_type]);

  // ---- Auto-set Transport Type to Export when Sea is selected ----
  useEffect(() => {
    if (formik.values.trans_mode === 'Sea' && formik.values.trans_type !== 'Export') {
      formik.setFieldValue('trans_type', 'Export');
    }
  }, [formik.values.trans_mode]);

  // ---- Redux state ----
  const {
    loadingJobOrderApprovedCustomerList,
    JobOrderApprovedCustomerList,
    loadingJobOrderCompanyBranchList,
    JobOrderCompanyBranchList,
    loadingJobOrderEmployeeList,
    JobOrderEmployeeList,
    loadingUnusedQuotationByCompanyList,
    UnusedQuotationByCompanyList,
    loadingJobOrderPortList,
    JobOrderPortList,
  } = useSelector((state) => state?.JoborderReducer);

  const { loadingOrganisationAgentList, OrganisationAgentList } = useSelector(
    (state) => state?.OrganisationListReducer
  );

  const {
    loadingFFAirExpOrganisationList,
    FFAirExpOrganisationList,
  } = useSelector((state) => state?.FFAirExpReducer);

  // ---- Local state for dropdown options ----
  const [customerOptions, setCustomerOptions] = useState([]);
  const [consigneeOptions, setConsigneeOptions] = useState([]);
  const [shipperOptions, setShipperOptions] = useState([]);
  const [branchOption, setBranchOption] = useState([]);
  const [quotationOption, setQuotationOptions] = useState([]);
  const [agentOptions, setAgentOptions] = useState([]);
  const [loadingAgentList, setLoadingAgentList] = useState(false);
  const [parentAgentDetail, setParentAgentDetail] = useState('');
  const [portOptions, setPortOptions] = useState([]);

  // ---- Dispatch actions on mount ----
  useEffect(() => {
    dispatch(getAllApprovedCustomers(token, user_id));
    dispatch(getJobOrderEmployeeList(token, user_id));
    dispatch(getOrganisationAgentList(token, user_id));
    dispatch(getJobOrderPortList());
    dispatch(getFFAirExpOrganisation(token, user_id));
  }, []);

  useEffect(() => {
    setLoadingAgentList(!!loadingOrganisationAgentList);
  }, [loadingOrganisationAgentList]);

  // ---- Build organisation options ----
  const [organisationOptions, setOrganisationOptions] = useState([]);
  useEffect(() => {
    if (FFAirExpOrganisationList) {
      let arr = [];
      FFAirExpOrganisationList.map(val =>
        arr.push({
          value: val.id,
          label: `${val.name} (${val.customerType})`,
          entity: val.entity_type ? JSON.parse(val.entity_type) : [],
        })
      );
      setOrganisationOptions(arr);
    }
  }, [FFAirExpOrganisationList]);

  useEffect(() => {
    if (organisationOptions.length) {
      const shipperArr = organisationOptions.filter(obj =>
        obj.entity && obj.entity.includes('shipper')
      );
      const consigneeArr = organisationOptions.filter(obj =>
        obj.entity && obj.entity.includes('consignee')
      );
      setShipperOptions(shipperArr);
      setConsigneeOptions(consigneeArr);
    }
  }, [organisationOptions]);

  // ---- Other options ----
  useEffect(() => {
    if (OrganisationAgentList && Array.isArray(OrganisationAgentList)) {
      let arr = OrganisationAgentList.map((v) => ({
        value: v.id,
        label: `${v.name}${v.alias ? ' (' + v.alias + ')' : ''}`,
      }));
      setAgentOptions(arr);
    } else {
      setAgentOptions([]);
    }
  }, [OrganisationAgentList]);

  useEffect(() => {
    if (JobOrderApprovedCustomerList) {
      let arr = JobOrderApprovedCustomerList.map((v) => ({
        value: v.id,
        label: `${v.name} ${v.alias ? '( ' + v.alias + ' )' : ''} - ${v.customerType} ${v.entity ? '{' + v.entity + '}' : ''
          }`,
        parent_agent: v.parent_agent,
      }));
      if (formik.values.trans_mode === 'Sea' && formik.values.trans_type === 'Export') {
        arr = [{ value: 'other', label: 'Other', parent_agent: '' }, ...arr];
      }
      setCustomerOptions(arr);
    }
  }, [JobOrderApprovedCustomerList, formik.values.trans_mode, formik.values.trans_type]);

  // ---- Auto-select newly created customer ----
  useEffect(() => {
    if (pendingCustomerId.current && JobOrderApprovedCustomerList && JobOrderApprovedCustomerList.length > 0) {
      const newCustomer = JobOrderApprovedCustomerList.find(c => c.id === pendingCustomerId.current);
      if (newCustomer) {
        formik.setFieldValue('customer_id', pendingCustomerId.current);
        formik.setFieldValue('other_customer_name', '');
        pendingCustomerId.current = null;
        toast.success(`Customer "${newCustomer.name}" selected.`);
      }
    }
  }, [JobOrderApprovedCustomerList, formik]);

  useEffect(() => {
    if (JobOrderPortList && Array.isArray(JobOrderPortList)) {
      let arr = JobOrderPortList.map((v) => ({ value: v.id, label: v.name }));
      setPortOptions(arr);
    } else {
      setPortOptions([]);
    }
  }, [JobOrderPortList]);

  useEffect(() => {
    if (JobOrderCompanyBranchList) {
      let arr = JobOrderCompanyBranchList.map((v) => ({ value: v.id, label: v.branch_name }));
      setBranchOption(arr);
    }
  }, [JobOrderCompanyBranchList]);

  useEffect(() => {
    if (UnusedQuotationByCompanyList) {
      let arr = UnusedQuotationByCompanyList.map((val) => ({
        value: val.id,
        label: `${val.ship_quotation_no}`,
        trans_mode: val.transport_mode,
        trans_type: val.transport_type,
      }));
      setQuotationOptions(arr);
    } else {
      setQuotationOptions([]);
    }
  }, [UnusedQuotationByCompanyList]);

  useEffect(() => {
    if (formik.values.customer_id && formik.values.is_direct_customer === true) {
      if (formik.values.customer_id !== 'other') {
        dispatch(getCompanyBranch(token, user_id, formik.values.customer_id));
      } else {
        setBranchOption([]);
        setQuotationOptions([]);
      }
    } else if (!formik.values.customer_id) {
      setBranchOption([]);
      setQuotationOptions([]);
    }
  }, [formik.values.customer_id]);

  useEffect(() => {
    if (
      formik.values.is_direct_customer === false &&
      formik.values.sub_agent_id
    ) {
      formik.setFieldValue('quotation_id', '');
      formik.setFieldValue('trans_mode', '');
      formik.setFieldValue('trans_type', '');
      dispatch(getUnusedQuotationByCustomerList(token, user_id, formik.values.sub_agent_id));
    } else if (formik.values.is_direct_customer === false && !formik.values.sub_agent_id) {
      setQuotationOptions([]);
    }
  }, [formik.values.sub_agent_id]);

  const handleCustomerChange = (option) => {
    formik.setFieldValue('customer_id', option.value);
    formik.setFieldValue('customer_branch_id', null);
    setParentAgentDetail(option.parent_agent || '');
    if (option.value === 'other') {
      setBranchOption([]);
      formik.setFieldValue('other_customer_name', '');
    } else {
      const selectedCustomer = customerOptions.find(o => o.value === option.value);
      if (selectedCustomer) {
        formik.setFieldValue('other_customer_name', selectedCustomer.label);
      }
    }
  };

  // ---- Handle Add Customer ----
  const handleAddCustomer = async () => {
    if (!customerForm.name.trim()) {
      toast.error('Customer Name is required');
      return;
    }
    if (!customerForm.address.trim()) {
      toast.error('Address is required');
      return;
    }
    if (!customerForm.email.trim()) {
      toast.error('Email is required');
      return;
    }
    if (!customerForm.mobile.trim()) {
      toast.error('Mobile number is required');
      return;
    }

    setSavingCustomer(true);
    try {
      const config = {
        headers: {
          'auth-token': Cookies.get('token'),
          'user_id': Cookies.get('flexichain_user_id'),
          'Content-Type': 'application/json',
        },
      };
      const payload = {
        name: customerForm.name,
        address: customerForm.address,
        email: customerForm.email,
        mobile: customerForm.mobile,
        gst: customerForm.gst || null,
      };
      const response = await axios.post(`${adminMainUrl}/api/organization/addIndividualCustomer`, payload, config);
      if (response.status === 200) {
        toast.success('Customer added successfully');
        pendingCustomerId.current = response.data.data.id;
        setShowAddCustomerModal(false);
        setCustomerForm({ name: '', address: '', email: '', mobile: '', gst: '' });
        dispatch(getAllApprovedCustomers(token, user_id));
      } else {
        toast.error(response?.data?.msg || 'Failed to add customer');
      }
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.msg || error.message || 'Error adding customer');
    } finally {
      setSavingCustomer(false);
    }
  };

  const displayJobNumber = () => {
    if (loadingJobOrders) return 'Loading...';
    const { sequence, year } = nextJobOrderNumber;
    return getFormattedJobNumber(sequence, year, formik.values.trans_mode, formik.values.trans_type);
  };

  // ---- Render ----
  return (
    <>
      <Offcanvas show={show} onHide={handleClose} placement={'end'} name={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Add Job Order</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form onSubmit={formik.handleSubmit} noValidate>
            <div className="row">
              {/* Direct Customer Radio */}
              <div className="col-md-12 mt-2">
                <div className="ms-2">
                  <label htmlFor="is_direct_customer" className="form-label mb-0">
                    Direct Customer
                  </label>
                  <div className="icon-forms mb-3 mb-sm-0 col-12">
                    <div className="row">
                      <div className="col-md-6">
                        <input
                          type="radio"
                          onChange={() => {
                            formik.resetForm();
                            formik.setFieldValue('is_direct_customer', true);
                            formik.setFieldValue('has_quotation', false);
                            setQuotationOptions([]);
                            setBranchOption([]);
                            setParentAgentDetail('');
                          }}
                          value={true}
                          id="is_direct_customer_yes"
                          className="me-1"
                          checked={formik.values.is_direct_customer === true}
                        />
                        <label htmlFor="is_direct_customer_yes">YES</label>
                      </div>
                      <div className="col-md-6">
                        <input
                          type="radio"
                          onChange={() => {
                            formik.resetForm();
                            formik.setFieldValue('is_direct_customer', false);
                            formik.setFieldValue('has_quotation', true);
                            setQuotationOptions([]);
                            setBranchOption([]);
                            setParentAgentDetail('');
                          }}
                          value={false}
                          id="is_direct_customer_no"
                          className="me-1"
                          checked={formik.values.is_direct_customer === false}
                        />
                        <label htmlFor="is_direct_customer_no">NO</label>
                      </div>
                    </div>
                  </div>
                  {formik.touched.is_direct_customer && formik.errors.is_direct_customer && (
                    <div className="text-danger small">{formik.errors.is_direct_customer}</div>
                  )}
                </div>
              </div>

              {/* ── YES (Direct Customer) ── */}
              {formik.values.is_direct_customer === true && (
                <>
                  <div className="col-md-12 mt-2">
                    <div className="ms-2">
                      <label className="form-label mb-0">Next Job Order Number</label>
                      <div className="icon-forms mb-3 mb-sm-0">
                        <input type="text" className="form-control form-control-sm" readOnly value={displayJobNumber()} />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 mt-2">
                    <div className="ms-2">
                      <label className="form-label mb-0">Transport Mode</label>
                      <div className="icon-forms mb-3 mb-sm-0">
                        <select
                          className="form-control form-control-sm"
                          name="trans_mode"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.trans_mode}
                        >
                          <option value="">Select Transport Mode</option>
                          <option value="Air">Air</option>
                          <option value="Sea">Sea</option>
                        </select>
                      </div>
                      {formik.touched.trans_mode && formik.errors.trans_mode && (
                        <div className="text-danger small">{formik.errors.trans_mode}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 mt-2">
                    <div className="ms-2">
                      <label className="form-label mb-0">Transport Type</label>
                      <div className="icon-forms mb-3 mb-sm-0">
                        <select
                          className="form-control form-control-sm"
                          name="trans_type"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.trans_type}
                        >
                          <option value="">Select Transport Type</option>
                          <option value="Import">Import</option>
                          <option value="Export">Export</option>
                        </select>
                      </div>
                      {formik.touched.trans_type && formik.errors.trans_type && (
                        <div className="text-danger small">{formik.errors.trans_type}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 mt-2">
                    <div className="ms-2">
                      <label className="form-label mb-0">Customer</label>
                      <div className="icon-forms mb-3 mb-sm-0">
                        <Select
                          className="custom-selector"
                          placeholder="Select a customer"
                          options={customerOptions}
                          styles={customStyles}
                          name="customer_id"
                          onChange={handleCustomerChange}
                          value={customerOptions.find((o) => o.value === formik.values.customer_id) || null}
                          isLoading={loadingJobOrderApprovedCustomerList}
                        />
                      </div>
                      {formik.touched.customer_id && formik.errors.customer_id && (
                        <div className="text-danger small">{formik.errors.customer_id}</div>
                      )}
                      {formik.values.trans_mode === 'Sea' &&
                        formik.values.trans_type === 'Export' &&
                        formik.values.customer_id === 'other' && (
                          <button
                            type="button"
                            className="btn btn-sm btn-primary mt-2"
                            onClick={() => setShowAddCustomerModal(true)}
                          >
                            <i className="ti ti-plus me-1"></i> Add New Customer
                          </button>
                        )}
                    </div>
                  </div>
                  {formik.values.trans_mode !== 'Sea' && (
                    <>
                      <div className="col-md-6 mt-2">
                        <div className="ms-2">
                          <label className="form-label mb-0">Branch</label>
                          <div className="icon-forms mb-3 mb-sm-0">
                            <Select
                              className="custom-selector"
                              placeholder="Select a branch"
                              options={branchOption}
                              styles={customStyles}
                              name="customer_branch_id"
                              onChange={(option) => formik.setFieldValue('customer_branch_id', option.value)}
                              value={branchOption.find((o) => o.value === formik.values.customer_branch_id) || null}
                              isLoading={loadingJobOrderCompanyBranchList}
                              isDisabled={formik.values.customer_id === 'other' || formik.values.customer_id === ''}
                            />
                          </div>
                          {formik.touched.customer_branch_id && formik.errors.customer_branch_id && (
                            <div className="text-danger small">{formik.errors.customer_branch_id}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mt-2">
                        <div className="ms-2">
                          <label className="form-label mb-0">Job Owner</label>
                          <div className="icon-forms mb-3 mb-sm-0">
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={jobOwnerName}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}

              {/* ── NO (Sub-Agent) ── */}
              {formik.values.is_direct_customer === false && (
                <>
                  <div className="col-md-12 mt-2">
                    <div className="ms-2">
                      <label className="form-label mb-0">Job Order Number</label>
                      <div className="icon-forms mb-3 mb-sm-0">
                        <input type="text" className="form-control form-control-sm" readOnly value={displayJobNumber()} />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 mt-2">
                    <div className="ms-2">
                      <label className="form-label mb-0">Select Sub Agent</label>
                      <div className="icon-forms mb-3 mb-sm-0">
                        <Select
                          className="custom-selector"
                          placeholder="Select Sub Agent"
                          options={agentOptions}
                          styles={customStyles}
                          name="sub_agent_id"
                          onChange={(option) => formik.setFieldValue('sub_agent_id', option.value)}
                          value={agentOptions.find((o) => o.value === formik.values.sub_agent_id) || null}
                          isLoading={loadingAgentList}
                        />
                      </div>
                      {formik.touched.sub_agent_id && formik.errors.sub_agent_id && (
                        <div className="text-danger small">{formik.errors.sub_agent_id}</div>
                      )}
                    </div>
                  </div>
                  {formik.values.trans_mode === 'Sea' && (
                    <div className="col-md-6 mt-2">
                      <div className="ms-2">
                        <label className="form-label mb-0">Shipper</label>
                        <div className="icon-forms mb-3 mb-sm-0">
                          <Select
                            className="custom-selector"
                            placeholder="Select Shipper"
                            options={shipperOptions}
                            styles={customStyles}
                            name="shipper"
                            onChange={(option) => formik.setFieldValue('shipper', option.value)}
                            value={shipperOptions.find((o) => o.value === formik.values.shipper) || null}
                            isLoading={loadingFFAirExpOrganisationList}
                          />
                        </div>
                        {formik.touched.shipper && formik.errors.shipper && (
                          <div className="text-danger small">{formik.errors.shipper}</div>
                        )}
                      </div>
                    </div>
                  )}
                  {formik.values.trans_mode !== 'Sea' && (
                    <>
                      <div className="col-md-6 mt-2">
                        <div className="ms-2">
                          <label className="form-label mb-0">Branch</label>
                          <div className="icon-forms mb-3 mb-sm-0">
                            <Select
                              className="custom-selector"
                              placeholder="Select a branch"
                              options={branchOption}
                              styles={customStyles}
                              name="customer_branch_id"
                              onChange={(option) => formik.setFieldValue('customer_branch_id', option.value)}
                              value={branchOption.find((o) => o.value === formik.values.customer_branch_id) || null}
                              isLoading={loadingJobOrderCompanyBranchList}
                            />
                          </div>
                          {formik.touched.customer_branch_id && formik.errors.customer_branch_id && (
                            <div className="text-danger small">{formik.errors.customer_branch_id}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mt-2">
                        <div className="ms-2">
                          <label className="form-label mb-0">Quotation</label>
                          <div className="icon-forms mb-3 mb-sm-0">
                            <Select
                              className="custom-selector"
                              placeholder="Select a Quotation"
                              options={quotationOption}
                              styles={customStyles}
                              name="quotation_id"
                              onChange={(option) => {
                                formik.setFieldValue('quotation_id', option.value);
                                formik.setFieldValue('trans_mode', option.trans_mode || '');
                                formik.setFieldValue('trans_type', option.trans_type || '');
                              }}
                              value={quotationOption.find((o) => o.value === formik.values.quotation_id) || null}
                              isLoading={loadingUnusedQuotationByCompanyList}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="col-md-6 mt-2">
                    <div className="ms-2">
                      <label className="form-label mb-0">Transport Mode</label>
                      <div className="icon-forms mb-3 mb-sm-0">
                        <select
                          className="form-control form-control-sm"
                          name="trans_mode"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.trans_mode}
                        >
                          <option value="">Select Transport Mode</option>
                          <option value="Air">Air</option>
                          <option value="Sea">Sea</option>
                        </select>
                      </div>
                      {formik.touched.trans_mode && formik.errors.trans_mode && (
                        <div className="text-danger small">{formik.errors.trans_mode}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 mt-2">
                    <div className="ms-2">
                      <label className="form-label mb-0">Transport Type</label>
                      <div className="icon-forms mb-3 mb-sm-0">
                        <select
                          className="form-control form-control-sm"
                          name="trans_type"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.trans_type}
                        >
                          <option value="">Select Transport Type</option>
                          <option value="Import">Import</option>
                          <option value="Export">Export</option>
                        </select>
                      </div>
                      {formik.touched.trans_type && formik.errors.trans_type && (
                        <div className="text-danger small">{formik.errors.trans_type}</div>
                      )}
                    </div>
                  </div>
                  {formik.values.trans_mode !== 'Sea' && (
                    <div className="col-md-6 mt-2">
                      <div className="ms-2">
                        <label className="form-label mb-0">Job Owner</label>
                        <div className="icon-forms mb-3 mb-sm-0">
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={jobOwnerName}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>

            {/* ── SEA extra fields ── */}
            {formik.values.trans_mode === 'Sea' && (
              <div className="row mt-3 border-top pt-3">
                <div className="col-md-6 mt-2">
                  <div className="ms-2">
                    <label className="form-label mb-0">Port of Loading (POL)</label>
                    <div className="icon-forms mb-3 mb-sm-0">
                      <Select
                        className="custom-selector"
                        placeholder="Select Port of Loading"
                        options={portOptions}
                        styles={customStyles}
                        name="pol"
                        onChange={(option) => formik.setFieldValue('pol', option.value)}
                        value={portOptions.find((o) => o.value === formik.values.pol) || null}
                        isLoading={loadingJobOrderPortList}
                      />
                    </div>
                    {formik.touched.pol && formik.errors.pol && (
                      <div className="text-danger small">{formik.errors.pol}</div>
                    )}
                  </div>
                </div>
                <div className="col-md-6 mt-2">
                  <div className="ms-2">
                    <label className="form-label mb-0">Port of Discharge (POD)</label>
                    <div className="icon-forms mb-3 mb-sm-0">
                      <Select
                        className="custom-selector"
                        placeholder="Select Port of Discharge"
                        options={portOptions}
                        styles={customStyles}
                        name="pod"
                        onChange={(option) => formik.setFieldValue('pod', option.value)}
                        value={portOptions.find((o) => o.value === formik.values.pod) || null}
                        isLoading={loadingJobOrderPortList}
                      />
                    </div>
                    {formik.touched.pod && formik.errors.pod && (
                      <div className="text-danger small">{formik.errors.pod}</div>
                    )}
                  </div>
                </div>
                <div className="col-md-6 mt-2">
                  <div className="ms-2">
                    <label className="form-label mb-0">Load Type</label>
                    <div className="icon-forms mb-3 mb-sm-0">
                      <Select
                        className="custom-selector"
                        placeholder="Select Load Type"
                        options={loadTypeOptions}
                        styles={customStyles}
                        name="load_type"
                        onChange={(option) => {
                          formik.setFieldValue('load_type', option.value);
                          formik.setFieldValue('total_weight', '');
                          formik.setFieldValue('weight_unit', 'Kg');
                          formik.setFieldValue('dimension_length', '');
                          formik.setFieldValue('dimension_width', '');
                          formik.setFieldValue('dimension_height', '');
                          formik.setFieldValue('dimension_unit', 'cm');
                          formik.setFieldValue('lcl_weight', '');
                          formik.setFieldValue('lcl_weight_unit', 'Kg');
                          formik.setFieldValue('incoterm', '');
                        }}
                        value={loadTypeOptions.find((o) => o.value === formik.values.load_type) || null}
                      />
                    </div>
                    {formik.touched.load_type && formik.errors.load_type && (
                      <div className="text-danger small">{formik.errors.load_type}</div>
                    )}
                  </div>
                </div>
                <div className="col-md-6 mt-2">
                  <div className="ms-2">
                    <label className="form-label mb-0">Shipment Type</label>
                    <div className="icon-forms mb-3 mb-sm-0">
                      <Select
                        className="custom-selector"
                        placeholder="Select Shipment Type"
                        options={shipmentTypeOptions}
                        styles={customStyles}
                        name="shipment_type"
                        onChange={(option) => formik.setFieldValue('shipment_type', option.value)}
                        value={shipmentTypeOptions.find((o) => o.value === formik.values.shipment_type) || null}
                      />
                    </div>
                    {formik.touched.shipment_type && formik.errors.shipment_type && (
                      <div className="text-danger small">{formik.errors.shipment_type}</div>
                    )}
                  </div>
                </div>
                <div className="col-md-6 mt-2">
                  <div className="ms-2">
                    <label className="form-label mb-0">Consignee</label>
                    <div className="icon-forms mb-3 mb-sm-0">
                      <Select
                        className="custom-selector"
                        placeholder="Select Consignee"
                        options={consigneeOptions}
                        styles={customStyles}
                        name="consignee_id"
                        onChange={(option) => formik.setFieldValue('consignee_id', option ? option.value : null)}
                        value={consigneeOptions.find((o) => o.value === formik.values.consignee_id) || null}
                        isLoading={loadingFFAirExpOrganisationList}
                        isClearable
                      />
                    </div>
                    {/* No error message for consignee – it's optional */}
                  </div>
                </div>

                {/* ✅ FCL: Total Weight with inline unit */}
                {formik.values.load_type === 'FCL' && (
                  <div className="row">
                    <div className="col-md-6 mt-2">
                      <div className="ms-2">
                        <label className="form-label mb-0">Total Weight *</label>
                        <div className="d-flex align-items-center gap-2">
                          <div style={{ flex: 2 }}>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              name="total_weight"
                              placeholder="Enter weight"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.total_weight}
                            />
                          </div>
                          <div style={{ flex: 1, minWidth: '100px' }}>
                            <Select
                              className="custom-selector"
                              options={weightUnitOptions}
                              styles={customStyles}
                              name="weight_unit"
                              onChange={(option) => formik.setFieldValue('weight_unit', option.value)}
                              value={weightUnitOptions.find((o) => o.value === formik.values.weight_unit) || null}
                              placeholder="Unit"
                            />
                          </div>
                        </div>
                        {formik.touched.total_weight && formik.errors.total_weight && (
                          <div className="text-danger small">{formik.errors.total_weight}</div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 mt-2">
                      <div className="ms-2">
                        <label className="form-label mb-0">Incoterm</label>
                        <div className="icon-forms mb-3 mb-sm-0">
                          <Select
                            className="custom-selector"
                            options={incotermOptions}
                            styles={customStyles}
                            name="incoterm"
                            onChange={(option) => formik.setFieldValue('incoterm', option ? option.value : null)}
                            value={incotermOptions.find((o) => o.value === formik.values.incoterm) || null}
                            isLoading={loadingIncoterms}
                            isClearable
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* ✅ LCL: Dimension and Weight with Unit labels */}
                {formik.values.load_type === 'LCL' && (
                  <div className="row">
                    {/* Dimension – L × W × H */}
                    <div className="col-md-6 mt-2">
                      <div className="ms-2">
                        <label className="form-label mb-1">Dimension (L × W × H)</label>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <div style={{ flex: 1 }}>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              name="dimension_length"
                              placeholder="Length"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.dimension_length}
                            />
                          </div>
                          <span style={{ fontSize: '18px', fontWeight: 'bold' }}>×</span>
                          <div style={{ flex: 1 }}>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              name="dimension_width"
                              placeholder="Width"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.dimension_width}
                            />
                          </div>
                          <span style={{ fontSize: '18px', fontWeight: 'bold' }}>×</span>
                          <div style={{ flex: 1 }}>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              name="dimension_height"
                              placeholder="Height"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.dimension_height}
                            />
                          </div>
                          {/* Unit label + dropdown inline (no Unit label above) */}
                          <div style={{ flex: '0 0 100px', minWidth: '80px' }}>
                            <Select
                              className="custom-selector"
                              options={dimensionUnitOptions}
                              styles={customStyles}
                              name="dimension_unit"
                              onChange={(option) => formik.setFieldValue('dimension_unit', option.value)}
                              value={dimensionUnitOptions.find((o) => o.value === formik.values.dimension_unit) || null}
                              placeholder="Select"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Weight (optional) */}
                    <div className="col-md-6 mt-2">
                      <div className="ms-2">
                        <label className="form-label mb-1">Weight (optional)</label>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <div style={{ flex: 1 }}>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              name="lcl_weight"
                              placeholder="Enter weight"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.lcl_weight}
                            />
                          </div>
                          <div style={{ flex: '0 0 100px', minWidth: '80px' }}>
                            <Select
                              className="custom-selector"
                              options={weightUnitOptions}
                              styles={customStyles}
                              name="lcl_weight_unit"
                              onChange={(option) => formik.setFieldValue('lcl_weight_unit', option.value)}
                              value={weightUnitOptions.find((o) => o.value === formik.values.lcl_weight_unit) || null}
                              placeholder="Select"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Incoterm */}
                    <div className="col-md-6 mt-2">
                      <div className="ms-2">
                        <label className="form-label mb-0">Incoterm</label>
                        <div className="icon-forms mb-3 mb-sm-0">
                          <Select
                            className="custom-selector"
                            options={incotermOptions}
                            styles={customStyles}
                            name="incoterm"
                            onChange={(option) => formik.setFieldValue('incoterm', option ? option.value : null)}
                            value={incotermOptions.find((o) => o.value === formik.values.incoterm) || null}
                            isLoading={loadingIncoterms}
                            isClearable
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Submit Button */}
            {(formik.values.is_direct_customer === true || formik.values.is_direct_customer === false) && (
              <div className="row d-flex justify-content-end mt-2">
                <div className="col-md-6 d-flex justify-content-end">
                  <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                    {disableSubmit ? (
                      <>
                        <i className="fas fa-spinner fa-spin"></i> Creating...
                      </>
                    ) : (
                      'Create Job & Next'
                    )}
                  </button>
                </div>
              </div>
            )}
          </form>
        </Offcanvas.Body>
      </Offcanvas>

      {/* ── Add New Customer Modal ── */}
      <Modal show={showAddCustomerModal} onHide={() => setShowAddCustomerModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12 mt-2">
              <div className="ms-2">
                <label className="form-label mb-0">Name *</label>
                <div className="icon-forms mb-3 mb-sm-0">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={customerForm.name}
                    onChange={(e) => setCustomerForm({ ...customerForm, name: e.target.value })}
                    placeholder="Enter customer name"
                    required
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12 mt-2">
              <div className="ms-2">
                <label className="form-label mb-0">Address *</label>
                <div className="icon-forms mb-3 mb-sm-0">
                  <textarea
                    className="form-control form-control-sm"
                    value={customerForm.address}
                    onChange={(e) => setCustomerForm({ ...customerForm, address: e.target.value })}
                    placeholder="Enter address"
                    rows="2"
                    required
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <div className="ms-2">
                <label className="form-label mb-0">Email *</label>
                <div className="icon-forms mb-3 mb-sm-0">
                  <input
                    type="email"
                    className="form-control form-control-sm"
                    value={customerForm.email}
                    onChange={(e) => setCustomerForm({ ...customerForm, email: e.target.value })}
                    placeholder="Enter email"
                    required
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <div className="ms-2">
                <label className="form-label mb-0">Mobile *</label>
                <div className="icon-forms mb-3 mb-sm-0">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={customerForm.mobile}
                    onChange={(e) => setCustomerForm({ ...customerForm, mobile: e.target.value })}
                    placeholder="Enter mobile number"
                    required
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 mt-2">
              <div className="ms-2">
                <label className="form-label mb-0">GST No.</label>
                <div className="icon-forms mb-3 mb-sm-0">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    value={customerForm.gst}
                    onChange={(e) => setCustomerForm({ ...customerForm, gst: e.target.value })}
                    placeholder="Enter GST number (optional)"
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-sm btn-secondary" onClick={() => setShowAddCustomerModal(false)}>
            Cancel
          </button>
          <button className="btn btn-sm btn-primary" onClick={handleAddCustomer} disabled={savingCustomer}>
            {savingCustomer ? (
              <>
                <i className="fas fa-spinner fa-spin"></i> Saving...
              </>
            ) : (
              'Save Customer'
            )}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddJobOrderByQuotationOffcanvas2;